import getDataValueCustomerInfoLoyaltySelect from 'modules/loyalty/redux/selectors/get-data-value-customer-info'
import { LOYALTY_DATA_KEY } from 'modules/loyalty/constants'

export default function getNextTierInfoLoyaltySelect (state) {
  return getDataValueCustomerInfoLoyaltySelect(LOYALTY_DATA_KEY.next_tier_info)(state)
}
